const slugifyIt = require('@sindresorhus/slugify')

export const slugify = (string) => {
  return slugifyIt(string, { separator: '_' })
}
